module.exports = __webpack_public_path__ + "static/media/saham-logo-ar.2c5cbe9c.svg";